<template>
  <v-row>
    <v-col
        v-for="(bg, i) in backgrounds"
        :key="i"
        cols="6"
        md="4"
        lg="3"
        xl="2"
    >
      <v-item>
        <v-card
            :class="[
                'd-flex align-center bg-card',
                { selected: selectedBackground && selectedBackground.component === bg.component }
            ]"
            :style="`background: url(${bg.thumb}) no-repeat center center;`"
            height="100"
            @click="selectedBackground = bg"
        >
          <div class="bg-backdrop"/>
          <v-spacer />
          <v-card-title class="font-weight-light text-center bg-name">{{bg.name}}</v-card-title>
          <v-spacer/>
        </v-card>
      </v-item>
    </v-col>
  </v-row>
</template>

<script>
  import {ColorSchemes} from "@/utils/UI";

  export default {
    created() {
      const vm = this
      vm.selectedBackground = vm.backgrounds.find(bg => bg.component === vm.value)
    },
    props: {
      value: {
        type: String
      }
    },
    data(){
      return {
        selectedBackground: null,
        backgrounds: [
          {
            name: 'Original',
            description: 'Fondo estático que cambia a tono oscuro o claro según el contraste seleccionado',
            component: 'DefaultBackground',
            thumb: require('@/assets/img/bg/default-background.png'),
            minColors: 0,
            maxColors: 0,
            animated: false,
            defaultColors: []
          },
          {
            name: 'Gradient',
            description: 'Fondo degradé con colores configurables',
            component: 'GradientBackground',
            thumb: require('@/assets/img/bg/gradient-background.png'),
            minColors: 2,
            maxColors: 4,
            animated: true,
            defaultColors: ColorSchemes.Kyra
          },
          {
            name: 'Lights',
            description: 'Fondo de luces con colores configurables',
            component: 'LightsBackground',
            thumb: require('@/assets/img/bg/lights-background.png'),
            minColors: 3,
            maxColors: 3,
            animated: true,
            defaultColors: [ColorSchemes.Aurora]
          },
          {
            name: 'Waves',
            description: 'Ondas en movimiento con colores configurables',
            component: 'WavesBackground',
            thumb: require('@/assets/img/bg/waves-background.png'),
            minColors: 2,
            maxColors: 4,
            animated: true,
            defaultColors: ColorSchemes.Aurora
          },
        ]
      }
    },
    watch: {
      selectedBackground(val){
        const vm = this
        if(val) vm.$emit('change', val)
      }
    }
  }
</script>

<style scoped>

  .bg-card{
    border: 2px solid transparent;
    background-size: cover !important;
    position: relative;;
  }

  .bg-card .bg-backdrop{
    background-color: rgba(255, 255, 255, .6);
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .bg-card .bg-name{
    z-index: 1;
    color: #000;
  }

  .bg-card.selected{
    border: 2px solid var(--v-accent-base);
  }

</style>